import apiClient from "./client";

export const paymentApi = {
  getMethods: async () => {
    const response = await apiClient.get("/payments/methods");
    return response.data;
  },

  startPayment: async (storeRequestId, method) => {
    const response = await apiClient.post(
      `/payments/requests/${storeRequestId}`,
      { method },
    );
    return response.data;
  },
  startWebsitePayment: async (websiteRequestId, method) => {
    const response = await apiClient.post(
      `/payments/website-requests/${websiteRequestId}`,
      { method },
    );
    return response.data;
  },

  getAdminSettings: async () => {
    const response = await apiClient.get("/payments/admin/settings");
    return response.data;
  },

  updateAdminSettings: async (settings) => {
    const response = await apiClient.put("/payments/admin/settings", settings);
    return response.data;
  },

  getAdminPayments: async () => {
    const response = await apiClient.get("/payments/admin/all");
    return response.data;
  },

  confirmPayment: async (paymentId, transactionId) => {
    const response = await apiClient.post(
      `/payments/admin/${paymentId}/confirm`,
      { transactionId },
    );
    return response.data;
  },

  deletePendingPayment: async (paymentId) => {
    const response = await apiClient.delete(`/payments/admin/${paymentId}`);
    return response.data;
  },
};
